import React from 'react';

interface TabHeadlineProps {
    title: string;
}

function TabHeadline({ title }: TabHeadlineProps) {
    return (
        <div className="h-[50px] flex items-center mb-6 pl-16">
            <h3 className="p-0 m-0">{title}</h3>
        </div>
    );
}

export default TabHeadline;
